import React, { FunctionComponent } from 'react';

import { AttachmentGallery } from '@components/share_manifests/components/gallery-view/AttachmentGallery';

import { useFetchAssets } from '@components/share_manifests/components/gallery-view/useFetchAssets';

import classes from './styles/attachment-gallery.module.scss';

export interface GalleryViewProps {
  sectionKeys: string[];
}

export const GalleryView: FunctionComponent<GalleryViewProps> = ({
  sectionKeys,
}) => {
  const { assets, error, loading } = useFetchAssets({ sectionKeys });

  if (error)
    return (
      <div role="alert">
        {bfTranslate('There was an error fetching asset data')}
      </div>
    );

  if (loading) return null;

  return (
    <div
      className={classes.galleryViewContainer}
    >
      { assets.length ? (
        <AttachmentGallery assets={assets} />
      ) : (
        <div role="alert">{bfTranslate('No assets found')}</div>
      )}
    </div>
  );
};